export default "__VITE_ASSET__b011eae9__"